import { validarSesion } from "./Auth";
const config = require("../env.json")

export const obtenerActividades=async(token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/actividades`;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
}

export const obtenerSerie=async(serieId,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/actividadesfecha/serie/`+serieId;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
}
export const obtenerActividadesFechaTodas=async(fecha,funcionaria,token)=>{
   
    const url=config.REACT_APP_WEBAPI_URL+`/actividadesfecha?funcionaria=`+funcionaria+`&start=`+fecha.start+`&end=`+fecha.end;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
}

export const actualizarActividadFecha=async(actividadFecha,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/actividadesfecha`;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"PUT",
            body:JSON.stringify(actividadFecha)
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
}

export const eliminarActividadFecha=async(actividadFecha,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/actividadfecha/`;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"POST",
            body:JSON.stringify(actividadFecha)
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
}
export const ingresarActividadFecha=async(actividad,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/actividadesfecha`;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"POST",
            body:JSON.stringify(actividad)
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
}

export const eliminarActividadFechaSerie=async(actividad,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/actividadesfecha/serie/`;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"DELETE",
            body:JSON.stringify(actividad)
            
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
}

export const actualizarActividadFechaSerie=async(serie,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/actividadesfecha/serie`;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"PUT",
            body:JSON.stringify(serie)
        }
        );
    validarSesion(resp.status)
    console.log(JSON.stringify(resp))
    const {data}=await resp.json();
    return data;
}

